// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__root-vOVNxs","slotTargetChildren":"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__slotTargetChildren-MAIkrf","text__gSlk":"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__text__gSlk-rtYOri","textGSlk":"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__text__gSlk-rtYOri"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__root-vOVNxs\",\"slotTargetChildren\":\"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__slotTargetChildren-MAIkrf\",\"text__gSlk\":\"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__text__gSlk-rtYOri\",\"textGSlk\":\"src-wab-client-plasmic-plasmic_kit_user_mentions-PlasmicUserMentionDisplay-module__text__gSlk-rtYOri\"}";
        // 1793541993517
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  